module.exports = __webpack_public_path__ + "img/user.c711bff0.png";